import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Input, Spinner } from 'reactstrap';
import classNames from 'classnames';

import ImageApi from 'apis/image';

import './style.scss';

function InputFile(props) {
    const {
        absoluteDefaultValue,
        setValue,
        setError,
        clearError,
        name,
        maxSize = Number.MAX_SAFE_INTEGER,
        innerRef, ...restOfProps } = props;
    const { t } = useTranslation();
    const { t: trans } = useTranslation();
    const [absoluteUrl, setAbsoluteUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setAbsoluteUrl(absoluteDefaultValue);
    }, [absoluteDefaultValue]);

    const handleChange = async (e) => {
        let file = e.target.files[0];
        if (file) {
            clearError(name);

            const sizeFile = file.size / (1080 * 1080);
            if (sizeFile > maxSize) {
                file = null;
                e.target.value = null;

                toast.error(trans(`File is larger than ${maxSize * 1000000} bytes`));
            } else {
                setIsLoading(true);
                await ImageApi.upload(file).then(res =>{
                    setAbsoluteUrl(res.absolute_url);
                    setValue(name, res.relative_url);
                }).catch((err) => {
                    setError(name, 'error', t(err.message));
                });
                setIsLoading(false);
            }
        }
    };

    const renderPreview = () => {
        if (absoluteUrl) {
            return (<div className={classNames(
                'input-file-preview-wrapper',
                { active: isLoading }
            )}>
                {isLoading && (
                    <Spinner
                        className="center-loading input-file-preview-loading"
                        size="lg" color="primary" />
                )}
                <img alt='preview-input' style={{ width: '200px' }} src={absoluteUrl}/>
            </div>);
        }
        return null;
    };

    return (
        <>
            <Input type="file" onChange={handleChange}/>
            <Input
                innerRef={innerRef}
                {...restOfProps}
                name={name}
                type="hidden"/>
            {renderPreview()}
        </>
    );
}

export default InputFile;
